import React from "react";
import Lottie from "react-lottie";
import "./Exlamentry_lottie.css";
import animationData from "./Exlamentry_lottie.json";

const Exlamentry_lottie = () => {

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <section className="main">
      <div className="Exlamentry_lottie_icon">
        <Lottie
          options={defaultOptions}
        />
      </div>
    </section>
  );
};

export default Exlamentry_lottie;